import { createContext, useContext, useState } from 'react';

// Create a context
const GlobalStateContext = createContext();

// Create a provider component
export function GlobalStateProvider({ children }) {
  const [globalState, setGlobalState] = useState(/* initial state */);
  const [buState, setBuState] = useState('ALL');
  const [buName,setBuName] = useState("");
  const [openFullScreen, setOpenFullScreen] =  useState(false);
  const [refreshDashboard, setRefreshDashboard] = useState(0);

  return (
    <>
      <GlobalStateContext.Provider value={{ globalState, setGlobalState, buState, setBuState , buName, setBuName, openFullScreen, setOpenFullScreen,refreshDashboard,setRefreshDashboard}}>
        {children}
      </GlobalStateContext.Provider>
    </>
  );
}

// Create a custom hook to access the context
export function useGlobalState() {
  return useContext(GlobalStateContext);
}
